<template>
    <div
        v-html="require(`!!html-loader!@icons/${name}.svg`).default" 
        class="fill-current"
    ></div>
</template>

<script>
    /**
     * Icon
     *
     * This is when you an icon to be reactive
     * @component
     */

    export default {
        props: {
            name: {
                default: '',
                type: String,
                required: true,
            },
        },
    }
</script>